/**
 * Stable small-integer hashing for seeding {@link mulberry32}, so a given
 * exercise's distractor set (and target position) is stable for the whole
 * day but still varies day to day and across items.
 */

/**
 * Today's date key in the learner's local timezone, e.g. `"2026-07-04"`.
 * Injectable `date` for tests; defaults to `new Date()`.
 */
export function dateKey(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/**
 * A small, fast, deterministic string hash (djb2 variant) folded into a
 * 32-bit signed integer — good enough as a {@link mulberry32} seed, not for
 * anything cryptographic.
 */
export function hashSeed(text: string): number {
  let hash = 5381;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 33) ^ text.charCodeAt(i);
  }
  return hash | 0;
}
